import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import DashboardCard from './DashboardCard';

import { useTranslation } from 'react-i18next';
import { AtNoData } from '../../../components/AtNoData';

const ReleaseChart = ({ data, isLoading }) => {
    const { t } = useTranslation();
    const safeData = data || { versions: [], positive: [], negative: [], neutral: [] };

    const options = {
        chart: {
            type: 'column',
            height: 300,
            style: { fontFamily: 'inherit' }
        },
        title: { text: null },
        credits: { enabled: false },
        xAxis: {
            categories: safeData.versions,
            crosshair: true,
            labels: {
                style: { fontSize: '10px', color: '#6B7280' }
            }
        },
        yAxis: {
            min: 0,
            title: { text: null },
            gridLineColor: '#F3F4F6'
        },
        tooltip: {
            shared: true,
            formatter() {
                const rows = this.points
                    .map((p) => `<span style="color:${p.color}">●</span> ${p.series.name}: <b>${p.y}</b>`)
                    .join('<br/>');
                const total = this.points[0]?.point?.stackTotal ?? this.points[0]?.total;
                return `<b>${t('sentiment.charts.versionLabel')} ${this.x}</b><br/>${rows}<br/>${t('sentiment.charts.totalLabel')}: <b>${total}</b>`;
            }
        },
        plotOptions: {
            column: {
                stacking: 'normal',
                pointWidth: 20,
                borderWidth: 0,
                borderRadius: 2
            },
            series: {
                stickyTracking: true
            }
        },
        legend: {
            align: 'right',
            verticalAlign: 'top',
            floating: true,
            y: -15,
            symbolRadius: 10
        },
        series: [
            {
                name: t('sentiment.charts.positive'),
                data: safeData.positive,
                color: '#10B981'
            },
            {
                name: t('sentiment.charts.neutral'),
                data: safeData.neutral,
                color: '#F59E0B'
            },
            {
                name: t('sentiment.charts.negative'),
                data: safeData.negative,
                color: '#EF4444'
            }
        ]
    };

    const isEmpty = safeData.versions.length === 0;

    return (
        <DashboardCard title={t('sentiment.charts.releaseTitle')} isLoading={isLoading}>
            {isEmpty && !isLoading ? (
                <AtNoData />
            ) : (
                <HighchartsReact highcharts={Highcharts} options={options} />
            )}
        </DashboardCard>
    );
};

export default ReleaseChart;
